export const environment = {
  production: true,
  isMoc: false,
  isApiMoc: false,
  clientId: '04a9b673-d6d1-4ce2-9926-625c810d57d9',
  authApiUrl: 'https://account.identakid.net/api',
  authAppUrl: 'https://account.identakid.net/#',
  identityApiUrl: 'https://identity.ccssvm.com/api',
  version: 'v1.2.3'
};
